(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets/assets/javascripts/play/components/animated-backgrounds/pacman-background.js') >= 0) return;  svs.modules.push('/modules/tickets/assets/javascripts/play/components/animated-backgrounds/pacman-background.js');
"use strict";

const _React = React,
  useRef = _React.useRef,
  useEffect = _React.useEffect;
setGlobal('svs.tickets.play.components.animatedBackgrounds.PacmanBackground', () => {
  const ref = useRef();
  useEffect(() => {
    let pacmanPositions = _.shuffle([20, 27, 39, 51, 63, 75, 87]);
    let trails = [];
    let interval;
    function createTrail(_ref) {
      let selector = _ref.selector,
        noDelay = _ref.noDelay;
      selector = $(selector);
      if (selector.length) {
        let speed = 0; 
        let top = 0; 
        let delay = 0; 

        speed = Math.round(Math.random() * 20) + 20; 
        top = pacmanPositions.pop();
        delay = noDelay ? 0 : Math.round(Math.random() * 2); 

        speed = speed / (svs.core.detect.breakpoint.greaterThan('sm') ? 1 : 2);
        delay = delay * (svs.core.detect.breakpoint.greaterThan('sm') ? 1 : 2);
        const pacmanTrail = $("<div class=\"scratch-pacman\" style=\"top: ".concat(top, "vh; animation-delay: ").concat(delay, "s; animation-duration: ").concat(speed, "s\"></div>"));
        selector.append(pacmanTrail);
        pacmanTrail.on('webkitAnimationEnd oanimationend msAnimationEnd animationend', () => {
          pacmanPositions.unshift(top);
          pacmanTrail.remove();
        });
        return pacmanTrail;
      }
    }
    function reset() {
      pacmanPositions = _.shuffle([20, 27, 39, 51, 63, 75, 87]);
      trails.forEach(trail => {
        trail.remove();
      });
      clearInterval(interval);
    }
    if (ref.current) {
      reset();
      setTimeout(() => {
        trails.push(createTrail({
          selector: ref.current,
          noDelay: true
        }));
      }, 1000); 
      interval = setInterval(() => {
        if (document.querySelector('.bg-skrapspel-pacman')) {
          trails.push(createTrail({
            selector: ref.current
          }));
        } else {
          reset();
        }
      }, 6000);
    }
    return () => {
      reset();
    };
  }, [ref]);
  return React.createElement("div", {
    className: "animated-background-container",
    ref: ref
  });
});

 })(window);